module.exports = __webpack_public_path__ + "img/OilMatrix_BLGR_grd_cropped.363774ed.png";